<template>
  <div class="px-1 pt-10">
    <v-row
      align="center"
      сlass="ma-0"
      style="margin-left: 0; margin-right: 0"
    >
      <div class="text-h6 mr-3">Кнопочный промокод</div>
      <v-divider />
    </v-row>
    <template v-if="item">
      <v-row
        align="start"
        class="mt-6"
        no-gutters
        :key="key"
      >
        <v-col style="max-width: 300px">
          <v-text-field
            outlined
            dense
            hide-details
            :max="2"
            label="Заголовок"
            v-model="item.button_promocode_description.title"
          />
          <v-text-field
            outlined
            dense
            hide-details
            :max="2"
            class="mt-4 custom-field"
            label="Текст кнопки"
            v-model="item.button_promocode_description.button_title"
          />
          <v-text-field
            v-model="colorValue"
            label="Цвет фона"
            dense
            outlined
            hide-details="auto"
            :rules="[colorRule]"
            placeholder="#FFFFFF"
            class="flex-grow-1 mt-4"
            @input="validateAndNormalize"
          >
            <template v-slot:append>
              <div
                :style="{
                  backgroundColor: isValidColor ? colorValue : '#FFFFFF',
                  width: '24px',
                  height: '24px',
                  borderRadius: '4px',
                  border: '1px solid rgba(0, 0, 0, 0.24)',
                  marginTop: '-2px'
                }"
              ></div>
            </template>
          </v-text-field>
        </v-col>
        <div class="ml-4">
          <ImageUploader
            :image="item.button_promocode_description.image"
            :aspect-ratio="1"
            @input="uploadImage($event, 'button_promocode_image')"
            :read-only="!$auth.hasRight('promocode_condition__edit')"
          ></ImageUploader>
        </div>
      </v-row>
    </template>
  </div>
</template>

<script>
  import ImageUploader from '@/admin/components/ImageUploader.vue'

  export default {
    name: 'PromocodeConditionButtonPromoDescription',
    components: { ImageUploader },
    computed: {},
    props: {
      item: Object
    },
    emits: ['inited'],
    data: () => {
      return {
        imagesToSetAfterCreateByField: null,
        key: 0,
        colorValue: '#FFFFFF'
      }
    },
    computed: {
      isValidColor() {
        return this.checkColor(this.colorValue)
      }
    },
    watch: {
      colorValue(newValue) {
        if (this.isValidColor) {
          this.item.button_promocode_description.background_color = newValue
        }
      }
    },
    methods: {
      checkColor(color) {
        const hexRegex = /^#([A-Fa-f0-9]{6})$/
        return hexRegex.test(color)
      },
      colorRule(value) {
        return this.checkColor(value) || 'Некорректный формат (например, #FFFFFF)'
      },
      validateAndNormalize(val) {
        if (val && !val.startsWith('#')) {
          this.colorValue = '#' + val
        }
      },
      async uploadImage(file, field) {
        if (!this.item.id) {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          this.imagesToSetAfterCreateByField = file
          reader.onload = () => {
            this.item.button_promocode_description.image = reader.result
            key++
          }
        } else {
          const formData = new FormData()
          formData.append('image', file)
          formData.append('type', field)
          const res = await this.$promocodeCondition.sendPutSingle(
            'set_image',
            this.item.id,
            formData
          )
          const resImage = res.button_promocode_description.image || null
          this.item.button_promocode_description.image = resImage
          this.$store.commit('setSnackbar', {
            color: 'success',
            text: 'Изображение сохранено'
          })
        }
      },
      afterSave(_) {
        if (this.imagesToSetAfterCreateByField) {
          void this.uploadImage(this.imagesToSetAfterCreateByField, 'button_promocode_image')
        }
      }
    },
    mounted() {
      this.colorValue = this.item.button_promocode_description.background_color || '#FFFFFF'
    }
  }
</script>

<style scoped></style>
